/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { UPDATE_REFINANCED_CONTRACT_REQUEST, success, failure } from './action';

const update = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(UPDATE_REFINANCED_CONTRACT_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((payload) =>
      AjaxRequest.open(
        'post',
        `/admin/contractloancustom/loans/${payload.contractId}/updatecontractrefinanced/${payload.refinancedContractId}`,
        {
          ...payload.fields,
        },
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(update);
